import { toast } from "react-toastify";
import { getApiBaseUrl } from "../../utils/apiBaseUrl";

/**
 * Add / upload images for an existing address.
 *
 * @param addressId - The ID of the address.
 * @param files - Images to upload.
 * @param token - Authentication token.
 * @param t - Translation function.
 * @returns A promise that resolves to the API response.
 */
export async function addAddressImagesAsync(
  addressId: number,
  files: File[],
  token: string,
  t: (key: string) => string
): Promise<any> {

  if (!navigator.onLine) {
    toast.error(t("internetConnection"), { toastId: "offline-error" });
    return null;
  }

  try {
    const baseUrl = getApiBaseUrl();

    const formData = new FormData();

    files.forEach((file) => {
      formData.append("images", file);
    });

    const response = await fetch(
      `${baseUrl}/api/address/AddAddressImagesAsync?addressId=${addressId}`,
      {
        method: "POST",
        headers: {
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`,
        },
        body: formData,
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(
        `Error: ${response.status} ${response.statusText} - ${JSON.stringify(errorData)}`
      );
    }

    const result = await response.json();
    return result;

  } catch (error) {
    throw error;
  }
}